import Decimal from 'decimal.js'

// UI percent input ("5") -> proto fraction string ("0.05"). Shared by the band
// percentages and anywhere else a percent-style input needs to cross the wire.
export function percentToFraction(uiPercent: string): string {
  const n = Number(uiPercent)
  if (!Number.isFinite(n)) return '0'
  return new Decimal(n).dividedBy(100).toString()
}

// Seconds (as entered by the user, matching the plain-TWAP cadence inputs) -> proto
// milliseconds string, mirroring build-trigger-fire-payload.ts's
// `raw.twapFrequencySeconds * 1000` conversion for TwapCadence.Frequency.
export function secondsToMs(seconds: number): string {
  if (!Number.isFinite(seconds)) return '0'
  return Math.round(seconds * 1000).toString()
}

const UINT32_MAX = 4294967295

// Parses a total-slices input as a positive integer within uint32 range. Returns
// undefined for an empty/unset input (server default applies), null for an invalid one
// so callers can distinguish "not provided" from "provided but bad."
export function parseTotalSlices(raw: string | undefined): number | undefined | null {
  if (!raw || raw.trim() === '') return undefined
  const n = Number(raw)
  if (!Number.isInteger(n) || n <= 0 || n > UINT32_MAX) return null
  return n
}
